import gql from 'graphql-tag';

import { TRAFFICKING_FILTERS_FRAGMENT } from '../fragments/traffickingFiltersFragment';

export const GET_TRAFFICKING_FILTERS = gql`
  query GET_TRAFFICKING_FILTERS($shareableId: String!) {
    getTraffickingFilters(shareableId: $shareableId) {
      ...traffickingFilters
    }
  }
  ${TRAFFICKING_FILTERS_FRAGMENT}
`;
